import "./skills-Dj4T8Duc.js";
import { MCP_SERVER_NAME } from "./constants-CEZaLsGe.js";
import "./errors-CEDWDXew.js";
import "./slug-validation-MJ3jU0Hd.js";
import "./schema-DKEjeVqP.js";
import { logIssue } from "./logging-B7X3yL0T.js";
import "./events-datasets-Cu37u43g.js";
import "./url-utils-CYEhmNHi.js";
import { LIB_VERSION } from "./version-Dl3bNTAd.js";
import "./api-path-BQDQ2sHi.js";
import { isApiAuthenticationErrorDeep } from "./errors-DG2FreDU.js";
import "./schema-BYZYkgA1.js";
import "./client-IUNQkit5.js";
import "./types-Brcky9_F.js";
import "./api-client-SsChedgx.js";
import { formatErrorForUser, isExpectedToolError } from "./error-handling-BsZo3KBt.js";
import "./constraint-helpers-C-VlK4t-.js";
import "./surfaces-B1_F0pzt.js";
import "./types-DGnYE-i7.js";
import { executeToolHandler, getAvailableTools, getFilteredInputSchema, injectConstraintParams, resolveToolDescription } from "./availability-zLnbaxcD.js";
import "./define-SD6AQa4b.js";
import "./validate-region-url-C2aYIha9.js";
import "./api-EaEPyKlQ.js";
import "./results-NF1RJbDZ.js";
import "./whoami-Bz6QKirR.js";
import "./find-organizations-CXTZEMsb.js";
import "./find-teams-ZsyAWNb7.js";
import "./find-projects-BYeZfQDF.js";
import "./find-releases-fkgr4qqZ.js";
import "./type-guards-DHLAzjf2.js";
import "./api-formatting-nIGXUFdx.js";
import "./project-constraints-DlfcU4mm.js";
import "./get-release-details-0bKoH-Gv.js";
import "./dashboards-BCwvH2V2.js";
import "./find-dashboards-DE0x5cIv.js";
import "./get-dashboard-details-7tf-4Q_F.js";
import "./find-monitors-DOaVdrCU.js";
import "./get-monitor-details-CP_Cj6P3.js";
import "./uptime-monitors-DdMrkrKy.js";
import "./find-uptime-monitors-NZjkNLjM.js";
import "./get-uptime-monitor-details-DfFRiDqD.js";
import "./create-uptime-monitor-fo-rIhsm.js";
import "./update-uptime-monitor-CXyi5lFD.js";
import "./delete-uptime-monitor-CHj4Cluv.js";
import "./find-alert-rules-Co9XjMKY.js";
import "./alerts-CVOIE5iC.js";
import "./get-alert-rule-WfTdEa_v.js";
import "./tool-call-formatting-ALc98KqF.js";
import "./ai-conversation-actions-rbKawWyG.js";
import "./enhance-error-BDXGhe5E.js";
import "./url-scope-CRM5sNo7.js";
import "./issue-helpers-0Dnme3Ym.js";
import "./code-location-DW_YNpMG.js";
import "./seer-BoTKAK7k.js";
import "./user-formatting-BrX0Xi05.js";
import "./formatting-Cviy8-dX.js";
import "./issue-D65xI0F7.js";
import "./code-location-C0fIXD0V.js";
import "./get-issue-details-DHDUffp5.js";
import "./event-stacktrace-DNVGqkZt.js";
import "./get-event-stacktrace-ODRk7GSR.js";
import "./get-issue-activity-CKhQWy99.js";
import "./breadcrumbs-BltIlpas.js";
import "./get-issue-breadcrumbs-D5AeF8Vm.js";
import "./get-issue-tag-values-DtJZnl37.js";
import "./get-issue-user-reports-D73TLuX2.js";
import "./anthropic-provider-CRd6GA4E.js";
import "./azure-openai-provider-BNAjkBmg.js";
import "./openai-provider-DK3FdwQ_.js";
import "./openrouter-provider-JT8w8qQ6.js";
import "./provider-factory-Cs_2DBhe.js";
import "./resolve-region-url-DutLwiPb.js";
import "./semantic-display-Zyyjp_BY.js";
import "./get-trace-details-D7U8b5_V.js";
import "./get-span-details-DfXIT1v_.js";
import "./url-helpers-CcAcmPuu.js";
import "./get-replay-details-BWeEKq_j.js";
import "./blob-utils-CdbE_jsd.js";
import "./get-event-attachment-h8oTTPZt.js";
import "./formatting-Dh3LlFmw.js";
import "./update-issue-q9a5YNJb.js";
import "./provider-fallback-L61Pbfxx.js";
import "./callEmbeddedAgent-ffwEeqdP.js";
import "./utils-DHwF0RI3.js";
import "./dataset-fields-CBauoBBr.js";
import "./otel-semantics-DGeu0HI-.js";
import "./whoami-DU_KhHDm.js";
import "./config-BqCCImAX.js";
import "./utils-Dg2aeBEb.js";
import "./agent-BCH9XRWB.js";
import "./analyzer-CtmUqCwO.js";
import "./formatters-Cuh2gD9M.js";
import "./replays-Dg9Syytd.js";
import "./search-events-C8aVtdIY.js";
import "./create-team-Bz1tSDLQ.js";
import "./create-project-CTQakq9G.js";
import "./update-project-BYY10KTt.js";
import "./add-team-to-project-DrTGc_T9.js";
import "./remove-team-from-project-CT7eqBf7.js";
import "./create-dsn-C-kIpqG7.js";
import "./find-dsns-DCUQXIHr.js";
import "./update-dsn-Ce0IWsRx.js";
import "./fetch-utils-By3YW-Mv.js";
import "./analyze-issue-with-seer-Dy01BWPf.js";
import "./search-docs-DVVQKCxP.js";
import "./get-doc-CnSvhrTG.js";
import "./config-lLg5qzu0.js";
import "./agent-BIAUd2t1.js";
import "./formatters-3Z1cdvzp.js";
import "./search-issues-CQ0efOru.js";
import "./config-ChOUIglS.js";
import "./utils-_4r1K2PE.js";
import "./agent-Bbb5dUlD.js";
import "./search-issue-events-fYjr_r6r.js";
import "./formatter-UsEdX-DU.js";
import "./get-profile-CilEVKTg.js";
import "./get-profile-details-B7TCia0B.js";
import "./get-agent-conversation-details-DTJR8hFg.js";
import "./formatting-C_fxwUSt.js";
import "./handlers-CCIzlp0E.js";
import "./get-snapshot-Ce1Z98WR.js";
import "./get-snapshot-image-CWtW-DQz.js";
import "./get-sentry-resource-DAx17Rhc.js";
import "./get-latest-base-snapshot-KoSAQyLF.js";
import "./search-agent-conversations-CUhIOq09.js";
import "./add-issue-note-DqTid9mJ.js";
import "./onboarding-status-update-ZaTsL300.js";
import "./catalog-DaTB1cy-.js";
import "./schema-BuKqZlvC.js";
import "./search-CX6pdulw.js";
import "./search-tools-CbtWC7w4.js";
import "./execute-tool-B_06lhoJ.js";
import { tools_default } from "./tools-fGO-TOBm.js";
import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { McpServer as McpServer$1 } from "@modelcontextprotocol/server";
import { getActiveSpan, setTag, setUser, wrapMcpServerWithSentry } from "@sentry/core";

//#region src/server.ts
function getSkillGrantedAttributeName(skill) {
	return `app.consent.skill.${skill.replaceAll("-", "_")}.granted`;
}
function isCallToolResult(output) {
	return !!output && typeof output === "object" && !Array.isArray(output) && Array.isArray(output.content);
}
/**
* Detects structured-only tool output. Full CallToolResult objects are excluded
* so compatibility text generation stays centralized in server.ts.
*/
function isStructuredToolOutput(output) {
	return !!output && typeof output === "object" && !Array.isArray(output) && "structuredContent" in output && !("content" in output) && !!output.structuredContent && typeof output.structuredContent === "object" && !Array.isArray(output.structuredContent);
}
/**
* Wraps structured-only output in an MCP CallToolResult with generated JSON
* text for clients that do not read structuredContent yet.
*/
function structuredOutputToCallToolResult(output) {
	return {
		content: [{
			type: "text",
			text: JSON.stringify(output.structuredContent, null, 2)
		}],
		structuredContent: output.structuredContent
	};
}
function buildServer({ context, experimentalMode = false, tools: customTools, sdkVersion = "v1" }) {
	const contextWithModes = {
		...context,
		experimentalMode
	};
	const serverInfo = {
		name: MCP_SERVER_NAME,
		version: LIB_VERSION
	};
	if (sdkVersion === "v2") {
		const server$1 = new McpServer$1(serverInfo);
		const registrations$1 = configureServer({
			server: server$1,
			context: contextWithModes,
			experimentalMode,
			tools: customTools
		});
		for (const { name, config, handler } of registrations$1) server$1.registerTool(name, config, handler);
		return wrapMcpServerWithSentry(server$1);
	}
	const server = new McpServer(serverInfo);
	const registrations = configureServer({
		server,
		context: contextWithModes,
		experimentalMode,
		tools: customTools
	});
	for (const { name, config, handler } of registrations) server.registerTool(name, config, handler);
	return wrapMcpServerWithSentry(server);
}
/**
* Configures an MCP server with tools filtered by granted skills.
*
* Internal function used by buildServer(). Use buildServer() instead for most cases.
* Tools are filtered at registration time based on grantedSkills, and context is
* captured in closures for tool handler execution.
*/
function configureServer({ server, context, experimentalMode = false, tools: customTools }) {
	const registrations = [];
	const registry = customTools ?? tools_default;
	const grantedSkills = context.grantedSkills ? new Set(context.grantedSkills) : void 0;
	const grantedSkillIds = grantedSkills ? Array.from(grantedSkills).sort() : void 0;
	const availableTools = getAvailableTools({
		tools: registry,
		context,
		experimentalMode,
		useDefaultSurfacePolicy: !customTools
	});
	const toolsToRegister = availableTools.filter(({ isTopLevel }) => isTopLevel);
	const contextWithToolAvailability = {
		...context,
		availableToolNames: new Set(availableTools.flatMap(({ key, tool }) => [key, tool.name])),
		directToolNames: new Set(toolsToRegister.flatMap(({ key, tool }) => [key, tool.name]))
	};
	server.server.onerror = (error) => {
		const transportLogOptions = {
			loggerScope: ["server", "transport"],
			contexts: { transport: { phase: "server.onerror" } }
		};
		logIssue(error, transportLogOptions);
	};
	for (const { tool } of toolsToRegister) {
		const filteredInputSchema = getFilteredInputSchema(tool, contextWithToolAvailability);
		const resolvedDescription = resolveToolDescription(tool, {
			experimentalMode,
			availableToolNames: contextWithToolAvailability.availableToolNames,
			directToolNames: contextWithToolAvailability.directToolNames
		});
		const toolRegistration = {
			description: resolvedDescription,
			inputSchema: filteredInputSchema,
			outputSchema: tool.outputSchema,
			annotations: tool.annotations
		};
		const handleToolCall = async (params) => {
			const activeSpan = getActiveSpan();
			if (activeSpan) {
				activeSpan.setAttribute("app.server.mode.experimental", experimentalMode);
				if (context.transport) activeSpan.setAttribute("app.transport", context.transport);
				if (context.clientFamily) activeSpan.setAttribute("app.client.family", context.clientFamily);
				if (context.constraints.organizationSlug) activeSpan.setAttribute("app.constraint.organization_slug", context.constraints.organizationSlug);
				if (context.constraints.projectSlug) activeSpan.setAttribute("app.constraint.project_slug", context.constraints.projectSlug);
				if (grantedSkillIds?.length) for (const skill of grantedSkillIds) activeSpan.setAttribute(getSkillGrantedAttributeName(skill), true);
			}
			if (context.userId) {
				const user = {
					id: context.userId,
					...context.userIpAddress ? { ip_address: context.userIpAddress } : {}
				};
				setUser(user);
			}
			if (context.clientId) setTag("client.id", context.clientId);
			if (context.clientFamily) setTag("app.client.family", context.clientFamily);
			if (context.transport) setTag("app.transport", context.transport);
			setTag("app.server.mode.experimental", experimentalMode);
			try {
				const rawParams = params && typeof params === "object" && !Array.isArray(params) ? params : {};
				const paramsWithConstraints = injectConstraintParams(rawParams, tool, contextWithToolAvailability);
				if (activeSpan) for (const [key, value] of Object.entries(paramsWithConstraints)) {
					const attributeValue = value == null || typeof value === "object" ? JSON.stringify(value) : value;
					activeSpan.setAttribute(`gen_ai.tool.call.arguments.${key}`, attributeValue);
				}
				const output = await executeToolHandler({
					tool,
					params: rawParams,
					context: contextWithToolAvailability
				});
				if (activeSpan) activeSpan.setStatus({ code: 1 });
				if (typeof output === "string") return { content: [{
					type: "text",
					text: output
				}] };
				if (Array.isArray(output)) return { content: output };
				if (isCallToolResult(output)) return output;
				if (isStructuredToolOutput(output)) return structuredOutputToCallToolResult(output);
				throw new Error(`Invalid tool output: ${output}`);
			} catch (error) {
				if (activeSpan) {
					activeSpan.setStatus({ code: 2 });
					if (!isExpectedToolError(error)) activeSpan.recordException(error);
				}
				if (isApiAuthenticationErrorDeep(error) && context.onUpstreamUnauthorized) try {
					await context.onUpstreamUnauthorized();
				} catch {}
				return {
					content: [{
						type: "text",
						text: await formatErrorForUser(error, { transport: context.transport })
					}],
					isError: true
				};
			}
		};
		registrations.push({
			name: tool.name,
			config: toolRegistration,
			handler: handleToolCall
		});
	}
	return registrations;
}

//#endregion
export { buildServer };
//# sourceMappingURL=server.js.map